import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { graphql, gql, compose } from 'react-apollo';
import {
    FormControl
} from 'react-bootstrap';

// Locale
import messages from '../../locale/messages';
import { get } from 'https';
import { connect } from 'react-redux';
import { change } from 'redux-form';

class CountryList extends Component {

    static propTypes = {
        data: PropTypes.shape({
            loading: PropTypes.bool.isRequired,
            getCountries: PropTypes.arrayOf(PropTypes.shape({
                id: PropTypes.number.isRequired,
                countryCode: PropTypes.string.isRequired,
                countryName: PropTypes.string.isRequired,
                isEnable: PropTypes.bool.isRequired
            }).isRequired)
        }).isRequired,
        isEmptyFirst: PropTypes.bool,
        formatMessage: PropTypes.any
    };

    static defaultProps = {
        data: {
            getCountries: []
        },
        isEmptyFirst: false,
        dialCode: false
    }

    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    async handleChange(e, input) {
        const { data: { loading, getCountries }, dialCode, getSelected, change, formName, isCompanyCountry, isNationality } = this.props;

        let selectedItem = null;
        let currentValue = e.target.value;

        if (!loading && getCountries) {
            if (dialCode) {
                selectedItem = getCountries.find(o => o.dialCode == currentValue);
            } else {
                selectedItem = getCountries.find(o => o.countryCode == currentValue);
            }
        }

        if (getSelected) {
            getSelected(e, selectedItem);
            if (formName === 'EditProfileForm') {
                await change(formName, 'phoneCountryCode', selectedItem.countryCode);
                await change(formName, 'phoneDialCode', selectedItem.dialCode);
            }

            //Hack
            if(isCompanyCountry) {
                await change(formName, 'companyCountry', selectedItem.countryCode);

            } else if (isNationality) {
                await change(formName, 'nationality', selectedItem.countryCode);
            }  else  {
                await change(formName, 'countryName', selectedItem.countryCode);
            }
        }

        return e;
    }

    render() {
        const { data: { loading, getCountries }, className, input, isEmptyFirst, dialCode, onChange, onlyDACH } = this.props;
        const { formatMessage, locale } = this.props.intl;
        
        let formattedLocale = locale.includes("-") ? locale.split("-")[0].toUpperCase(): locale.toUpperCase()
        if(input.locale === "") {
            input.value = formattedLocale
        }
        let getCountriesTmp;
        if(!loading && getCountries != null && getCountries.length > 0) {
            getCountriesTmp  = [...getCountries];
           
    
            if(onlyDACH) {
                //filter countries for DACH Region
                getCountriesTmp = getCountriesTmp.filter(obj => obj.countryCode == "DE" || obj.countryCode == "AT" | obj.countryCode == "CH")
            }

        }
     
        return (
            <div>
                <FormControl componentClass="select"
                    className={className}
                    {...input}
                    onChange={(e) => {
                        input.onChange(e);
                        this.handleChange(e, input);
                    }}
                >
                    {
                        loading && <option>{formatMessage(messages.country)}</option>
                    }

                    {
                        !loading && isEmptyFirst && <option value="">{formatMessage(messages.chooseCountry)}</option>
                    }

                    {
                        !loading && getCountriesTmp != null && getCountriesTmp.length > 0 && !dialCode && getCountriesTmp.map((item) => {
                            return (
                                <option value={item.countryCode} key={item.id}>{item.countryName}</option>
                            )
                        })
                    }
                    {
                        !loading && getCountriesTmp != null && getCountriesTmp.length > 0 && dialCode && getCountriesTmp.map((item) => {
                            return (
                                <option value={item.dialCode} key={item.id}>{item.countryName}</option>
                            )
                        })
                    }
                </FormControl>
            </div>
        );
    }
}

const mapState = (state) => ({});

const mapDispatch = {
    change
};

export default compose(
    injectIntl,
    connect(mapState, mapDispatch),
    graphql(gql`
    query getCountries {
        getCountries{
            id
            countryCode
            countryName
            isEnable
            dialCode
        }
    }
`, { options: { ssr: false } })
)(CountryList);
